import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";
import "./index.css";
import { Provider } from "react-redux";
import store from "./Lib/Store/index.jsx";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./Components/Layout/index.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        {/* <App /> */}
        <Layout />
      </Provider>
    </Router>
  </React.StrictMode>
);
